module.exports = {
      id: "filter-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "sprite-99dfb162d59834e1e55e619b64a45f56.svg#filter",
      toString: function () {
        return this.url;
      }
    }